<template>
  <div
    :id="content.id"
    class="confirmation dynamic-component"
    @click="close()"
  >
    <div
      class="box"
      @click.stop
    >
      <div class="header rounded-t bg-primary p-4">
        <h3
          v-if="content.header"
          class="text-typeLight p-0"
        >
          {{ content.header }}
        </h3>
      </div>
      <div class="p-4 text-sm rounded-b bg-white">
        <div
          v-if="content.message"
          class="confirmation-message text-typeDark leading-relaxed"
          v-html="content.message"
        />
        <div
          v-if="content.bodyComponent"
          class="confirmation-body mt-3"
        >
          <component
            :is="content.bodyComponent"
            @update-data="updateBodyComponentData"
          />
        </div>
        <template v-if="content.checkbox">
          <label class="checkbox-wrapper mt-4">{{ content.checkbox.message }}
            <input
              v-model="checkbox"
              type="checkbox"
            >
            <span class="checkmark" />
          </label>
        </template>
        <template v-if="content.formInput">
          <FormInput
            v-model="formInputValue"
            :label="content.formInput.label"
            :name="content.formInput.name"
            :initial-value="initialFormInput"
            rules="required"
          />
        </template>
        <div class="confirmation-footer pt-4 text-right space-x-2">
          <PrimaryButton
            v-if="!content.isPrompt"
            :click-action="() => close()"
            :ghost="true"
            :disabled="loading"
            :button-text="content.negativeActionText || 'Cancel'"
          />
          <PrimaryButton
            :click-action="() => submit()"
            :is-loading="loading"
            :disabled="disableSubmit"
            :button-text="content.positiveActionText || 'Confirm'"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import PrimaryButton from "../../components/Buttons/PrimaryButton";
import FormInput from "~/components/FormElements/FormInput.vue";
export default {
  components: {FormInput, PrimaryButton},
  props: {
    content: {
      type: Object,
      required: true
    },
    removeById: { type: Function, required: true }
  },
  data(){
    return {
      initialFormInput: null,
      checkbox: false,
      loading: false,
      bodyComponentData: null,
      formInputValue: null
    };
  },
  computed: {
    disableSubmit(){
      if(this.content.checkbox){
        return this.content.checkbox && this.content.checkbox.forceCheckbox && !this.checkbox;
      }
      if(this.content.formInput){
        return this.content.formInput && !this.formInputValue;
      }
      if (this.content.requireRadioSelection) {
        const selection = this.bodyComponentData?.[this.content.requireRadioSelectionName];
        if (!selection) {
          return true;
        }
        if (typeof selection === 'object') {
          return !selection.value;
        }
        return false;
      }
      return false;
    }
  },
  beforeMount() {
    if(this.content.formInput?.value){
      this.initialFormInput = this.content.formInput.value;
    }
  },
  mounted() {
    window.addEventListener('keydown', this.handleEscape);
    if(this.content.checkbox?.setCheckbox){
      this.checkbox = this.content.checkbox.setCheckbox;
    }
  },
  unmounted() {
    window.removeEventListener('keydown', this.handleEscape);
  },
  methods: {
    close() {
      if (this.content.negativeAction) {
        this.content.negativeAction();
      }
      this.remove();
    },
    async submit() {
      this.loading = true;
      if(this.content.bodyComponent){
        await this.content.action(this.bodyComponentData);
      }else{
        const value = this.content.formInput ? this.formInputValue?.value : this.checkbox;
        await this.content.action(value);
      }
      this.loading = false;
      this.remove();
    },
    remove() {
      window.removeEventListener('keydown', this.handleEscape);
      this.removeById(this.content.id);
    },
    handleEscape(e){
      if (e.key === 'Escape') {
        this.remove();
      }
    },
    updateBodyComponentData(data){
      this.bodyComponentData = data;
    }
  }
};
</script>

<style lang="scss" scoped>
.confirmation {
  background-color: rgba(0, 0, 0, 0.7);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: grid;
  align-items: center;
  z-index: 100;
}
.box {
  max-width: 500px;
  justify-self: center;
}
</style>
